export default "__VITE_ASSET__B9jQZ_pH__"